export enum EPartnerLandingRoute {
  buyer = '/partners/buyer',
  registrationPartners = '/partners/start',
}
